<template>
    <div class="page employeeConfig">
        <page-header :bread-crumb="true" :back-button="true" :sync="true" />
        <div class="wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="微信支付子商户管理" name="wechat" lazy>
                    <wechat-employee-config></wechat-employee-config>
                </el-tab-pane>
                <el-tab-pane label="支付宝授权商户列表" name="alipay" lazy>
                    <alipay-employee-config></alipay-employee-config>
                </el-tab-pane>
                <el-tab-pane label="银联授权商户列表" name="union" lazy>
                    <union-employee-config></union-employee-config>
                </el-tab-pane>
                <el-tab-pane label="易宝授权商户列表" name="yeepay" lazy>
                    <yee-employee-config></yee-employee-config>
                </el-tab-pane>
                <el-tab-pane label="百度渠道" name="baidu" lazy>
                    <baidu-employee-config></baidu-employee-config>
                </el-tab-pane>
                <el-tab-pane label="其他渠道" name="others" lazy>
                    <others-employee-config></others-employee-config>
                </el-tab-pane>
                <el-tab-pane label="商户转账配置" name="transfer" lazy>
                    <transfer-merchant-config></transfer-merchant-config>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import WechatEmployeeConfig from "./wechatEmployeeConfig.vue";
import AlipayEmployeeConfig from "./alipayEmployeeConfig.vue";
import UnionEmployeeConfig from "./unionEmployeeConfig.vue";
import YeeEmployeeConfig from "./yeeEmployeeConfig.vue";
import BaiduEmployeeConfig from "./baiduEmployeeConfig.vue";
import OthersEmployeeConfig from "./othersEmployeeConfig.vue";
import TransferMerchantConfig from "./transferMerchantConfig.vue";
export default {
    name: "employeeConfig",
    components: {
        WechatEmployeeConfig,
        AlipayEmployeeConfig,
        UnionEmployeeConfig,
        YeeEmployeeConfig,
        BaiduEmployeeConfig,
        OthersEmployeeConfig,
        TransferMerchantConfig,
    },
    data() {
        return {
            activeName: "wechat", //wechat == 微信支付子商户管理  alipay == 支付宝授权商户列表
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            
        },
    },
};
</script>

<style lang="scss">
@import "@/common/style.scss";
.employeeConfig.page {
    overflow-y: auto;
    .wrap {
        min-width: 1182px;
        min-height: 740px;
        border-radius: 2px;
        background: #ffffff;
        padding: 16px 16px 50px 16px;
        .creatTG {
            display: inline-block;
            width: 98px;
            height: 32px;
            background: #4d7efa;
            border-radius: 2px;
            color: #ffffff;
            margin-bottom: 10px;
            cursor: pointer;
        }
        .searchBox {
            .space {
                margin: 0 12px 12px 0;
            }
            .reset {
                margin: 0 15px 0 15px;
                text-align: center;
                width: 56px;
                height: 32px;
                border-radius: 2px;
                color: #565a66;
                border: 1px solid #dcdfe6;
                cursor: pointer;
            }
            .search {
                text-align: center;
                width: 56px;
                height: 32px;
                background: #4d7efa;
                border-radius: 2px;
                color: #ffffff;
                cursor: pointer;
            }
        }
        .tableList {
            margin-top: 15px;
            .page-box {
                margin-top: 17px;
                text-align: right;
            }
            .arrowMore {
                margin-right: 12px;
                fill: #818899;
            }
        }
    }
    .dialog {
        height: auto;
        .dialogList {
            max-height: 500px;
            padding: 32px 70px 40px 70px;
            overflow: auto;
            .tit {
                margin-top: 25px;
                .serial {
                    width: 24px;
                    height: 24px;
                    background: #f8a201;
                    font-size: 14px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #ffffff;
                    border-radius: 50%;
                }
                .text {
                    padding-left: 8px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #565a66;
                    line-height: 22px;
                    .goLogin {
                        display: inline-block;
                        width: 70px;
                        height: 22px;
                        background: #4d7efa;
                        border-radius: 2px;
                        color: #ffffff;
                        line-height: 22px;
                        text-align: center;
                    }
                }
            }
            img {
                width: 100%;
                margin-top: 8px;
                margin-bottom: 24px;
            }
        }
        .dialog-footer {
            border-top: 1px solid #ebeef5;
            height: 55px;
            padding: 0 16px;
            .dfcancle {
                margin-right: 8px;
                width: 74px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #dcdfe6;
                font-size: 14px;
                font-weight: 400;
                color: #565a66;
            }
            .dfconfirm {
                width: 74px;
                height: 32px;
                background: #4d7efa;
                border-radius: 2px;
                border: 1px solid #dcdfe6;
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
            }
        }
    }
}
</style>
